import { toJS } from 'mobx';
import isEqual from 'lodash/isEqual';
import cloneDeepWith from 'lodash/cloneDeepWith';

const omitFunctionProps = (collection) => {
  const omitFn = (objToProcess) => {
    if (objToProcess && typeof objToProcess === 'object') {
      Object.keys(objToProcess).forEach((propertyName) => {
        if (
          Object.prototype.hasOwnProperty.call(objToProcess, propertyName) &&
          typeof objToProcess[propertyName] === 'function'
        ) {
          // eslint-disable-next-line no-param-reassign
          delete objToProcess[propertyName];
        }
      });
    }
  };

  return cloneDeepWith(toJS(collection), omitFn);
};

const processData = (incObj, rootStore, collection, TypeClass) => {
  let existingObject = collection.find((f) => f._id === incObj._id);

  if (existingObject && !isEqual(omitFunctionProps(existingObject), omitFunctionProps(incObj))) {
    TypeClass.UpdateObject(incObj, existingObject, rootStore);
  } else if (!existingObject) {
    existingObject = new TypeClass(incObj, rootStore);
    collection.push(existingObject);
  }

  return existingObject;
};

const processIncomingData = (incObj, rootStore, collection, TypeClass) => {
  if (incObj) {
    if (Array.isArray(incObj)) {
      return [
        ...new Set(
          incObj.filter(Boolean).map((m) => processData(m, rootStore, collection, TypeClass))
        ),
      ];
    }

    return processData(incObj, rootStore, collection, TypeClass);
  }

  return null;
};

export default processIncomingData;
